import { apiRequest } from "@/api/client";
import { TTL_6_HOURS, cacheKey, cachedFetch } from "@/lib/api-cache";
import type { SocioEmpresasResponse } from "@/types/api";

/**
 * Lista as empresas em que uma pessoa/entidade é sócia (nome + documento
 * opcional). Cacheada em memória por 6h.
 */
export function fetchSocioEmpresas(
  nome: string,
  documento: string | null,
  page: number,
  pageSize: number,
  _signal?: AbortSignal,
): Promise<SocioEmpresasResponse> {
  const params = new URLSearchParams();
  // Match por chave: PJ (documento 14 díg.) casa só pelo documento — por isso o
  // nome só é enviado quando presente; o documento vai sempre que houver.
  if (nome) {
    params.set("nome", nome);
  }
  if (documento) {
    params.set("documento", documento);
  }
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  const path = `/socios/empresas?${params.toString()}`;
  return cachedFetch(cacheKey("GET /socios/empresas", path), TTL_6_HOURS, () =>
    apiRequest<SocioEmpresasResponse>(path),
  );
}
